module.exports = __webpack_public_path__ + "static/media/TUSD-USDT.ead8ffbe.png";